<template>
  <v-dialog v-model="open" max-width="500">
    <template v-slot:activator="{ props: activatorProps }">
      <v-btn 
        v-bind="activatorProps" 
        @click="onContactClick"
        color="primary"
        prepend-icon="mdi-email-outline"
        class="px-6"
      >
        Contact Seller
      </v-btn>
    </template>

    <template v-slot:default="{ isActive }">
      <v-card elevation="8" rounded="lg">
        <!-- Header -->
        <v-card-item class="bg-primary text-white pa-6">
          <v-card-title class="text-h5 font-weight-bold pa-0">
            <v-icon class="mr-2">mdi-email-multiple</v-icon>
            Seller Contact Information
          </v-card-title>
        </v-card-item>

        <!-- Content -->
        <v-card-text class="pa-6">
          <!-- Seller Name -->
          <div class="mb-6">
            <v-card variant="outlined" class="pa-4 bg-blue-grey-lighten-5">
              <div class="text-subtitle-2 text-medium-emphasis mb-2">
                <v-icon size="small" class="mr-1">mdi-account-circle</v-icon>
                Seller Name
              </div>
              <div class="text-h6 font-weight-bold">{{ item.sellername }}</div>
            </v-card>
          </div>

          <!-- Contact Methods -->
          <div class="mb-6">
            <h4 class="text-subtitle-1 font-weight-bold mb-4">Contact Methods</h4>
            
            <!-- Phone -->
            <v-card v-if="item && item.phone" variant="outlined" class="mb-4 pa-4">
              <div class="text-caption text-medium-emphasis mb-3">
                <v-icon size="small" class="mr-1">mdi-phone</v-icon>
                Call the Seller
              </div>
              <div class="text-body-2 font-weight-bold mb-3">{{ item.phone }}</div>
              <v-btn
                :href="'tel:' + item.phone"
                @click="logPhoneClick"
                color="success"
                size="large"
                block
                prepend-icon="mdi-phone-check"
              >
                Call Now
              </v-btn>
            </v-card>

            <!-- Email -->
            <v-card v-if="item && item.email" variant="outlined" class="pa-4">
              <div class="text-caption text-medium-emphasis mb-3">
                <v-icon size="small" class="mr-1">mdi-email</v-icon>
                Send an Email
              </div>
              <div class="text-body-2 font-weight-bold mb-3 break-all">{{ item.email }}</div>
              <v-btn
                :href="'mailto:' + item.email"
                @click="logEmailClick"
                color="primary"
                size="large"
                block
                prepend-icon="mdi-email-send"
              >
                Send Email
              </v-btn>
            </v-card>
          </div>

          <!-- Disclaimer -->
          <v-alert
            type="warning"
            variant="outlined"
            density="compact"
            class="mb-0"
          >
            <v-alert-title class="text-caption">Important Notice</v-alert-title>
            <div class="text-caption">
              All transactions are handled directly between you and the seller. Dan's Tech Services and Cemetery Community are not responsible for any transaction disputes. Please be cautious of suspicious listings and report any fraud.
            </div>
          </v-alert>
        </v-card-text>

        <!-- Actions -->
        <v-divider />
        <v-card-actions class="pa-4 justify-end">
          <v-btn
            variant="outlined"
            color="primary"
            @click="isActive.value = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
export default {
  name: 'ContactDialog',

  props: {
    item: Object
  },

  data: () => ({
    open: false
  }),

  watch: {
    open(newVal) {
      if (newVal) {
        this.logContactViewed();
      }
    }
  },

  methods: {
    onContactClick() {
      this.open = true;
    },
    logContactViewed() {
      fetch("https://app.cemeterycommunity.com:11000/api/addmarketplaceitemlog", {
        method: "POST",
        headers: {
          data: JSON.stringify({ type: 'Contact Viewed', itemid: this.item.id })
        }
      }).catch(err => console.error('Contact viewed log failed:', err));
    },
    logEmailClick() {
      fetch("https://app.cemeterycommunity.com:11000/api/addmarketplaceitemlog", {
        method: "POST",
        headers: {
          data: JSON.stringify({ type: 'Email Clicked', itemid: this.item.id })
        }
      }).catch(err => console.error('Email click log failed:', err));
    },
    logPhoneClick() {
      fetch("https://app.cemeterycommunity.com:11000/api/addmarketplaceitemlog", {
        method: "POST",
        headers: {
          data: JSON.stringify({ type: 'Phone Clicked', itemid: this.item.id })
        }
      }).catch(err => console.error('Phone click log failed:', err));
    },
  }
}
</script>

<style scoped>
.break-all {
  word-break: break-all;
}
</style>